import type { TranslationDictionary } from "./types";

export const PT_DICTIONARY: TranslationDictionary = {
    "app.newTask": "Novo",
    "app.newTaskAria": "Novo bate-papo",
    "sidebar.searchPlaceholder": "Solicitações de pesquisa ou tarefa ID",
    "sidebar.filters": "Filtros de tarefas",
    "sidebar.allRatios": "Todas as proporções",
    "sidebar.allOrientations": "Todas as orientações",
    "sidebar.allModes": "Todos os modos",
    "sidebar.allResolutions": "Todas as resoluções",
    "sidebar.activeTasks": "Tarefas ativas",
    "sidebar.topAnchors": "Navegação no horário principal",
    "sidebar.bottomAnchors": "Navegação no tempo inferior",
    "sidebar.resize": "Redimensionar barra lateral",
    "batch.selected": "0 selecionado",
    "batch.selectedCount": "{count} selecionado",
    "batch.archivedCount": "Bate-papos {count} arquivados",
    "batch.archiveFailed": "Falha no arquivamento em lote",
    "batch.runningCannotDeleteSelected": "Os bate-papos selecionados estão em execução e não podem ser excluídos",
    "batch.deleteTitle": "Excluir bate-papos {count}?",
    "batch.deleteMessage": "Isso também excluirá os arquivos de imagem locais.",
    "batch.deleteSkippedDetail": "{count} as tarefas em execução serão mantidas",
    "batch.deleteSkippedSuffix": ", {count} executando tarefas não excluídas",
    "batch.deletedCount": "Bate-papos {count} excluídos{skipped}",
    "batch.deleteFailed": "Falha na exclusão do lote",
    "action.archive": "Arquivo",
    "action.delete": "Excluir",
    "action.cancel": "Cancelar",
    "action.edit": "Editar",
    "action.clear": "Limpar",
    "action.paste": "Colar",
    "action.find": "Encontrar",
    "action.replace": "Substituir",
    "action.close": "Fechar",
    "action.confirm": "Confirmar",
    "action.confirmQuestion": "Confirmar ação?",
    "action.refresh": "Atualizar",
    "action.save": "Salvar",
    "action.add": "Adicionar",
    "action.new": "Novo",
    "action.import": "Importar",
    "action.export": "Exportar",
    "queue.empty": "Sem fila",
    "queue.emptyAria": "Status da fila: nenhuma tarefa na fila",
    "queue.jumpTitle": "Ir para tarefas ativas",
    "queue.emptyTitle": "Nenhuma tarefa na fila",
    "queue.channel": "Canais {count}",
    "queue.availableChannels": "Canais disponíveis {usable}/{total}",
    "queue.dispatching": "Agendamento · espera {waiting}",
    "queue.runningWaiting": "Executando {running} · esperando {waiting}",
    "queue.statusLabel": "Status da fila: {text} · {channelText}. Clique para ir para as tarefas ativas",
    "queue.runningActions": "Executando ações de fila de tarefas",
    "queue.waitingActions": "Aguardando ações da fila de tarefas",
    "queue.cancelRunning": "Cancelar",
    "queue.cancelRunningTitle": "Cancelar tarefa em execução",
    "queue.dragWaiting": "Arraste para reordenar a tarefa em espera",
    "queue.dragSort": "Arraste para classificar",
    "queue.moveUp": "Acima",
    "queue.moveUpTitle": "Mover tarefa em espera para cima",
    "queue.moveDown": "Para baixo",
    "queue.moveDownTitle": "Mover tarefa em espera para baixo",
    "queue.promote": "Superior",
    "queue.promoteTitle": "Mover a tarefa em espera para o topo",
    "queue.promoteFailed": "Falha ao mover para o topo",
    "queue.deleteWaitingShort": "Del",
    "queue.deleteWaitingTitle": "Excluir tarefa em espera",
    "queue.deleteWaitingTitleConfirm": "Excluir tarefa em espera?",
    "queue.deleteWaitingMessage": "Isso o remove da fila e da lista de histórico.",
    "queue.deleteQueuedFailed": "Falha ao excluir tarefa na fila",
    "queue.queuedDeleted": "Tarefa na fila excluída",
    "queue.cancelRunningConfirm": "Cancelar tarefa",
    "queue.cancelRunningTitleConfirm": "Cancelar tarefa em execução?",
    "queue.cancelRunningMessage": "A tarefa atual será interrompida. A história será mantida.",
    "queue.cancelRunningFailed": "Falha ao cancelar tarefa",
    "queue.runningCancelled": "Tarefa cancelada",
    "queue.reorderFailed": "Falha ao reordenar a fila",
    "queue.realtimeUpdateFailed": "Falha ao atualizar o status ativo",
    "queue.realtimeDisconnected": "A conexão de status ao vivo foi perdida. Atualize a página para recuperar.",
    "queue.readFailed": "Falha ao carregar a fila",
    "status.waiting": "Esperando",
    "status.shownActiveTasks": "Mostrando tarefas ativas",
    "status.jsonCopied": "JSON copiado",
    "taskStatus.submitting": "Enviando",
    "taskStatus.running": "Gerando",
    "taskStatus.runningWithElapsed": "Gerando · {elapsed}",
    "taskStatus.completed": "Concluído",
    "taskStatus.partialFailed": "Falha parcial",
    "taskStatus.failed": "Falha",
    "taskStatus.queued": "Na fila",
    "taskStatus.unknown": "Estado desconhecido",
    "taskStatus.task": "Tarefa",
    "taskStatus.connectionInterrupted": "Conexão interrompida",
    "taskStatus.lastFailed": "Última falha",
    "taskStatus.waitingRetry": "{reason}, aguardando para tentar novamente (tentativa {attempt}/{max})",
    "taskStatus.retrying": "{reason}, tentando novamente (tentativa {attempt}/{max})",
    "taskStatus.nonRetryableAttempt": "Tentativa {attempt}/{max}, não é possível tentar novamente",
    "taskStatus.manualRetryAvailable": "Parado; imagens com falha podem ser repetidas manualmente",
    "taskStatus.waitingRetryShort": "Aguardando retry",
    "taskStatus.retryingShort": "Tentando novamente",
    "taskStatus.nonRetryableShort": "Sem nova tentativa",
    "taskStatus.manualRetryShort": "Retry manual",
    "taskStatus.stoppedShort": "Parado",
    "taskStatus.runtime": "Duração {duration}",
    "taskStatus.runtimeCompleted": "Duração {duration} · concluído {time}",
    "taskStatus.completedAt": "Concluído {time}",
    "taskCard.count": "{count} imagens",
    "taskCard.successCount": "bem sucedido {count}",
    "taskCard.failedCount": "falhou {count}",
    "taskCard.runningCount": "gerando {count}",
    "taskCard.waitingCount": "esperando {count}",
    "taskCard.textToImageThumb": "Miniatura da tarefa de texto para imagem",
    "taskCard.imageToImageThumb": "Miniatura da tarefa imagem a imagem",
    "taskCard.failedThumb": "Falha na tarefa",
    "taskCard.textBadge": "T",
    "taskMode.edit": "Editar",
    "taskMode.generate": "Gerar",
    "document.generatingQueue": "Gerando · fila {total}",
    "document.queuedWaiting": "Na fila · esperando {count}",
    "runFeedback.editing": "Edição",
    "runFeedback.generating": "Gerando",
    "runFeedback.status": "{action}, decorrido {elapsed}",
    "footer.archive": "Arquivo",
    "footer.archiveCount": "Arquivo {count}",
    "footer.historyLibrary": "História",
    "historyLibrary.openFull": "Abra a biblioteca de histórico completa",
    "history.documentTitle": "História - 阿泰生图",
    "history.back": "Voltar ao gerador",
    "history.title": "História",
    "history.loading": "Carregando",
    "history.total": "Tarefas {total} · {archived} arquivadas",
    "history.search": "Pesquisar",
    "history.searchPlaceholder": "Solicitações de pesquisa ou tarefa ID",
    "history.clear": "Limpar",
    "history.type": "Tipo",
    "history.allTypes": "Todos os tipos",
    "history.type.textToImage": "Texto para imagem",
    "history.type.imageToImage": "Imagem para imagem",
    "history.month": "Mês",
    "history.status": "Estado",
    "history.promptMode": "Tratamento do prompt",
    "history.size": "Tamanho",
    "history.quality": "Qualidade",
    "history.ratio": "Proporção",
    "history.orientation": "Orientação",
    "history.backend": "Back-end",
    "history.provider": "Provedor",
    "history.archived": "Arquivado",
    "history.all": "Todos",
    "history.allMonths": "Todos os meses",
    "history.allStatuses": "Todos os status",
    "history.allPromptModes": "Todos os modos",
    "history.allSizes": "Todos os tamanhos",
    "history.allQualities": "Todas as qualidades",
    "history.allRatios": "Todas as proporções",
    "history.ratioOther": "Outro",
    "history.allOrientations": "Todas as orientações",
    "history.allBackends": "Todos os back-ends",
    "history.allProviders": "Todos os provedores",
    "history.unarchived": "Desarquivado",
    "history.archivedOnly": "Arquivado",
    "history.tasksAria": "Tarefas históricas",
    "history.taskListTitle": "Tarefas históricas",
    "history.browseNewest": "Procure o mais recente primeiro",
    "history.view": "Ver",
    "history.grid": "Grade",
    "history.list": "Lista",
    "history.sort": "Classificar",
    "history.newest": "O mais novo primeiro",
    "history.oldest": "Mais antigo primeiro",
    "history.refresh": "Atualizar",
    "history.selectedCount": "{count} tarefas selecionadas",
    "history.confirmDelete": "Confirmar exclusão",
    "history.detail": "Detalhe da tarefa",
    "history.detailTitle": "Tarefa de histórico",
    "history.closeDetail": "Fechar detalhes da tarefa",
    "history.resizeFilters": "Redimensionar barra lateral do filtro",
    "history.resizeDetail": "Redimensionar painel de detalhes",
    "history.detailEmpty": "Selecione uma tarefa histórica para visualizar detalhes",
    "history.loadingDetail": "Carregando detalhe...",
    "history.loadMore": "Carregar mais",
    "history.loadingMore": "Carregando...",
    "history.noMore": "Não há mais tarefas",
    "history.loadFailed": "Falha no carregamento. Atualize ou continue rolando para tentar novamente",
    "history.summaryFailed": "Falha ao carregar o resumo",
    "history.tasksFailed": "Falha ao carregar tarefas",
    "history.detailFailed": "Falha ao carregar detalhes",
    "history.noMatches": "Nenhuma tarefa correspondente",
    "history.loadedCount": "{count} carregado",
    "history.windowNotice": "A lista montada é limitada a tarefas {count}; role para cima ou para baixo para restaurar tarefas adjacentes sob demanda.",
    "history.selectTask": "Selecione a tarefa",
    "history.viewing": "Visualizando",
    "history.noPreview": "Nenhuma imagem de visualização",
    "history.downloadAll": "Baixar ZIP",
    "history.downloadImage": "Baixar imagem",
    "history.downloadSelected": "Download selecionado",
    "history.deleteUnselected": "Excluir não selecionado",
    "history.confirmDeleteUnselected": "Confirmar exclusão desmarcada",
    "history.selected": "Selecionado",
    "history.select": "Selecione",
    "history.downloadIndex": "Baixar {index}",
    "history.addReference": "Adicionar referência",
    "history.outputActions": "Ações de imagem de resultado",
    "history.inputReferences": "Referências de entrada",
    "history.inputReferenceIndex": "Referência de entrada {index}",
    "history.copyPrompt": "Solicitação de cópia",
    "history.copyPrompts": "Copiar solicitações",
    "history.copyPromptShort": "Copiar",
    "history.copyPromptPanel": "Copiar {title}",
    "history.copyOutputPromptPanel": "Copiar imagem {index} prompt revisado",
    "history.copyTaskIds": "Copiar tarefa IDs",
    "history.reuseTask": "Ver no gerador",
    "history.downloadTask": "Baixar",
    "history.downloadSelectedTasks": "Download em lote",
    "history.contextMenuLabel": "Menu de contexto da tarefa do histórico",
    "history.promptCopied": "Prompt copiado",
    "history.promptsCopied": "Prompts copiados de tarefas {count}",
    "history.taskIdsCopied": "Tarefa {count} copiada IDs",
    "history.promptCopiedShort": "Copiado",
    "history.promptCopyFailed": "Falha ao copiar o prompt",
    "history.promptCopyFailedShort": "Falha",
    "history.noPrompt": "Esta tarefa não tem prompt para copiar",
    "history.noPromptShort": "Vazio",
    "history.downloadStarted": "Download iniciado",
    "history.batchDownloadStarted": "Downloads iniciados para tarefas {count}",
    "history.noDownloadableOutputs": "Nenhuma imagem para download",
    "history.confirmDeleteSelected": "Confirmar exclusão selecionada",
    "history.openPreview": "Abrir visualização",
    "history.closePreview": "Fechar visualização",
    "history.untitled": "Sem título",
    "history.promptCompare": "Comparação imediata",
    "history.promptOriginal": "Solicitação original",
    "history.promptSubmitted": "Solicitação otimizada",
    "history.promptRevised": "Resultado revisado",
    "history.outputRevisedPromptTitle": "Imagem {index} prompt revisado",
    "history.outputRevisedPromptNotice": "Cada imagem tem seu próprio prompt revisado abaixo da imagem.",
    "history.promptEmpty": "Sem conteúdo",
    "history.promptMode.strict": "Fiel",
    "history.promptMode.original": "Original",
    "history.promptMode.off": "Automático",
    "history.quality.high": "Alto",
    "history.quality.medium": "Médio",
    "history.quality.low": "Baixo",
    "history.quality.auto": "Automático",
    "footer.batch": "Lote",
    "footer.storage": "Armazenamento",
    "footer.apiStatus": "Estado API: OK",
    "footer.version": "Versão {version}",
    "footer.versionInfo": "Informações da versão",
    "footer.versionLoading": "Versão...",
    "footer.updateBadge": "Nova versão disponível",
    "footer.updateAvailable": "Nova versão {version}",
    "version.title": "Versão e atualização",
    "version.loading": "Lendo o status da versão",
    "version.current": "Versão atual",
    "version.latest": "Versão mais recente",
    "version.source": "Tempo de execução",
    "version.sourcePortable": "Pacote portátil",
    "version.sourceStandard": "Standard app",
    "version.sourceSource": "Verificação de origem",
    "version.upToDate": "Você já está na versão mais recente",
    "version.updateAvailable": "A versão {version} está disponível. Feche a janela do servidor WebUI e execute o atualizador para atualizar.",
    "version.standardUpdateAvailable": "Version {version} is available. Updater-enabled macOS standard apps can install it from Check for Updates in the menu bar; this link remains the manual fallback.",
    "version.standardManualInstall": "Updater-enabled macOS standard apps support user-confirmed replacement; older macOS apps and Windows standard ZIP packages still update manually.",
    "version.noUpdater": "Este tempo de execução não é um pacote portátil, portanto o atualizador não pode ser iniciado automaticamente.",
    "version.openUpdater": "Iniciar atualizador",
    "version.release": "Ver lançamento",
    "version.updaterStarted": "Atualizador iniciado. Feche a janela atual do servidor WebUI e siga as instruções do atualizador.",
    "version.updaterFailed": "Não foi possível iniciar o atualizador. Execute o script do atualizador do pacote manualmente.",
    "version.historyTitle": "Novidades",
    "version.historyEmpty": "Nenhuma nota de versão disponível",
    "version.currentBadge": "Atual",
    "version.releaseDate": "{date}",
    "version.change.quick_gallery_picker": "Added a quick gallery modal picker with real-time search, multi-selection, and thumbnail optimizations.",
    "version.change.official_asset_library": "A biblioteca oficial de logotipos, slogans e assinaturas comerciais foi ampliada com mais marcas, linhas de negócio, formatos horizontais e verticais e variantes invertidas.",
    "version.change.material_picker_modal": "O seletor de materiais agora é uma janela com miniaturas grandes, categorias, pesquisa e seleção múltipla.",
    "version.change.brand_name": "O nome do produto passou a ser AI Innovation Studio em todos os idiomas.",
    "version.change.brand_templates": "Adicionamos modelos de marca selecionáveis e composição automática de logotipos, slogans e outros elementos.",
    "version.change.brand_preview": "Os resultados com marca agora permanecem consistentes na prévia, histórico, ampliação e download, mantendo a imagem original disponível.",
    "version.change.mobile_workspace": "Compactamos o cabeçalho móvel, a barra de ações, o resumo de materiais e a prévia vazia.",
    "version.change.task_center": "Compactamos o centro de tarefas móvel e adicionamos um indicador para tarefas em execução e espera.",
    "version.change.brand_launch": "Lançamos a experiência móvel da marca com os recursos visuais da Hengtai.",
    "version.change.core_workflow": "Entregamos o fluxo básico de geração, fila, histórico, galeria e configurações.",
    "notifications.title": "Notificações",
    "notifications.unread": "Notificações, {count} não lidas",
    "notifications.unreadSummary": "{count} não lido",
    "notifications.empty": "Nenhuma notificação de tarefa",
    "notifications.taskFailed": "Falha na tarefa",
    "notifications.taskPartial": "Tarefa parcialmente concluída",
    "notifications.taskCompleted": "Tarefa concluída",
    "notifications.generationFailed": "Falha na geração",
    "notifications.successCount": "{count} teve sucesso",
    "notifications.resultAvailable": "Resultados disponíveis",
    "notifications.failedCount": "{count} falhou",
    "notifications.systemUnsupported": "Este navegador não suporta notificações do sistema",
    "notifications.systemBlocked": "As notificações do sistema são bloqueadas pelo navegador. Ative-os nas configurações do navegador.",
    "notifications.systemDenied": "As notificações do sistema não estão habilitadas",
    "notifications.systemEnabled": "Notificações do sistema ativadas",
    "notifications.taskMissing": "A tarefa não existe ou foi excluída",
    "theme.label": "Tema",
    "theme.system": "Automático",
    "theme.light": "Claro",
    "theme.dark": "Escuro",
    "language.label": "Idioma da interface",
    "language.zh": "中",
    "language.zhCN": "简体中文",
    "language.zhTW": "正體中文",
    "language.zhHK": "繁体中文",
    "language.ja": "日本語",
    "language.ko": "한국어",
    "language.en": "English",
    "language.es": "Español",
    "language.pt": "Português",
    "language.fr": "Français",
    "language.de": "Deutsch",
    "language.ru": "Русский",
    "language.it": "Italiano",
    "language.hi": "हिन्दी",
    "auth.label": "Fonte de autenticação",
    "auth.checking": "Verificando autenticação",
    "auth.missingCodexSession": "Nenhuma sessão Codex detectada",
    "auth.switchFailed": "Falha ao mudar a fonte de autenticação",
    "auth.sourceUnavailable": "{source} indisponível",
    "auth.notActive": "Não ativo",
    "api.settings": "Configurações do sistema",
    "api.provider": "API provedor",
    "imageInput.title": "Imagens",
    "imageInput.uploadAria": "Clique, solte ou cole imagens e arquivos",
    "imageInput.uploadFull": "Clique, solte ou cole imagens e arquivos",
    "imageInput.uploadCompact": "Adicionar entrada",
    "imageInput.uploadSubtitle": "Compatível com imagens e arquivos de referência do Responses",
    "imageInput.recent": "Envios recentes",
    "imageInput.recentBadge": "Recente",
    "imageInput.uploadBadge": "Carregar",
    "imageInput.addToGallery": "Adicionar à galeria",
    "imageInput.addToGalleryShort": "Galeria",
    "imageInput.removeImage": "Remover imagem",
    "imageInput.editedBadge": "Editado",
    "imageInput.editImage": "Editar {name}",
    "imageInput.deletedRecent": "Upload recente excluído",
    "imageInput.deletedGallery": "Imagem da galeria excluída",
    "recentAssets.defaultName": "Carregamento recente",
    "recentAssets.use": "Usar {name}",
    "recentAssets.delete": "Excluir {name}",
    "recentAssets.deleteTitle": "Excluir upload recente?",
    "recentAssets.deleteMessage": "Isso removerá a imagem dos uploads recentes. Se estiver atualmente selecionado como entrada de imagem, será removido da entrada atual. As tarefas históricas que fazem referência a este upload recente perderão a visualização da entrada. A galeria pública não é afetada.",
    "recentAssets.loadFailed": "Falha ao carregar uploads recentes",
    "recentAssets.deleteFailed": "Falha ao excluir upload recente",
    "recentAssets.deleted": "Upload recente excluído",
    "inputSource.uploadFallback": "Imagem enviada",
    "inputSource.galleryFallback": "Imagem da galeria",
    "inputSource.focusPasteFallback": "{prefix}. A entrada de imagem está focada; pressione {shortcut} para colar imagens.",
    "inputSource.pastedCount": "Imagens da área de transferência {count} coladas",
    "inputSource.droppedCount": "Adicionadas imagens descartadas {count}",
    "inputSource.dropImagesOnly": "Soltar apenas arquivos de imagem",
    "inputSource.clipboardUnsupported": "Este navegador não consegue ler a área de transferência diretamente",
    "inputSource.clipboardEmpty": "Nenhuma imagem da área de transferência encontrada",
    "inputSource.clipboardDenied": "O navegador bloqueou o acesso direto à área de transferência",
    "inputSource.clipboardReadFailed": "Falha ao ler a área de transferência",
    "status.missingGalleryReference": "Uma imagem de referência da galeria foi excluída. Remova-o antes de gerar.",
    "status.missingRecentReference": "Uma imagem de referência de upload recente foi excluída. Remova-o antes de gerar.",
    "status.emptyPrompt": "Insira um prompt",
    "status.editNeedsImage": "O modo de edição requer pelo menos uma imagem",
    "status.loadedTask": "Tarefa carregada {taskId}",
    "status.reusedTask": "Tarefa aberta {taskId} no gerador",
    "status.loadingHistoryInputs": "Carregando imagens de entrada históricas...",
    "status.historyInputLoadFailed": "Falha ao carregar a imagem de entrada do histórico: {url}",
    "referenceCollector.alreadyStaged": "Já encenado como referência",
    "referenceCollector.staged": "Imagens de referência {count} encenadas",
    "referenceCollector.title": "Referências pendentes · {count}",
    "referenceCollector.addAll": "Adicione todas as referências",
    "referenceCollector.itemFallback": "Referência pendente",
    "referenceCollector.remove": "Remover referência pendente",
    "referenceCollector.cleared": "Referências pendentes apagadas",
    "referenceCollector.added": "Adicionadas imagens de referência {count}",
    "referenceCollector.addFailed": "Falha ao adicionar referências pendentes",
    "referenceCollector.readFailed": "Falha ao ler a imagem: {status}",
    "gallery.quick": "Galeria rápida",
    "gallery.current": "Galeria de categorias atuais",
    "gallery.categories": "Categorias da galeria",
    "gallery.categoryPortrait": "Retrato",
    "gallery.categoryCharacter": "Personagem",
    "gallery.categoryProduct": "Produto",
    "gallery.categoryPortraitRole": "Referência de retrato",
    "gallery.categoryCharacterRole": "Referência de personagem",
    "gallery.categoryProductRole": "Referência do produto",
    "gallery.referenceRole": "Imagem de referência",
    "gallery.manage": "Gerenciar galeria",
    "gallery.loadFailed": "Falha ao carregar a galeria",
    "gallery.imageOrderUpdateFailed": "Falha ao atualizar a ordem das imagens",
    "gallery.imageOrderUpdated": "Ordem das imagens atualizada",
    "gallery.categoryName": "Nome da categoria",
    "gallery.categoryPromptRole": "Função imediata",
    "gallery.categorySave": "Salvar",
    "gallery.categoryDelete": "Excluir",
    "gallery.categoryLoadFailed": "Falha ao carregar categorias",
    "gallery.categoryNameRequired": "Insira um nome de categoria",
    "gallery.categoryCreateFailed": "Falha ao adicionar categoria",
    "gallery.categoryCreated": "Categoria adicionada",
    "gallery.categorySaveFailed": "Falha ao salvar categoria",
    "gallery.categorySaved": "Categoria salva",
    "gallery.categoryDeleteTitle": "Excluir categoria da galeria?",
    "gallery.categoryDeleteMessage": "As imagens nesta categoria serão movidas para outra categoria. As imagens da galeria não serão excluídas.",
    "gallery.categoryDeleteConfirm": "Excluir categoria",
    "gallery.categoryDeleteFailed": "Falha ao excluir categoria",
    "gallery.categoryDeletedMigrated": "Categoria \"{name}\" excluída e imagens migradas",
    "gallery.categoryOrderUpdateFailed": "Falha ao atualizar a ordem das categorias",
    "gallery.categoryOrderUpdated": "Ordem das categorias atualizada",
    "gallery.categoryFallback": "Categoria da galeria",
    "gallery.imageFallback": "Imagem da galeria",
    "gallery.imageLoadFailed": "Falha ao carregar esta imagem",
    "gallery.editImageLoadFailed": "Falha ao carregar esta imagem para edição",
    "gallery.cannotAddImage": "Esta imagem não pode ser adicionada à galeria",
    "gallery.nameRequired": "Insira um nome de galeria",
    "gallery.saveFailed": "Falha ao salvar a imagem da galeria",
    "gallery.savedAsReference": "Adicionado à galeria e alterado para referência da galeria",
    "gallery.renameImage": "Renomear imagem da galeria",
    "gallery.moveToCategory": "Mover para categoria",
    "gallery.categoryRequired": "Escolha uma categoria de galeria",
    "gallery.promptNoteTitle": "Nota de referência da galeria",
    "gallery.updateFailed": "Falha ao atualizar a galeria",
    "gallery.selectImageFile": "Escolha um arquivo de imagem",
    "gallery.replaceImageFailed": "Falha ao substituir a imagem da galeria",
    "gallery.replacedImage": "Substituída a imagem de origem por \"{name}\"",
    "gallery.deleteImageTitle": "Excluir imagem da galeria?",
    "gallery.deleteImageMessage": "As referências históricas de tarefas serão exibidas como excluídas.",
    "gallery.deleteFailed": "Falha ao excluir a imagem da galeria",
    "gallery.deletedSuffix": "(excluído)",
    "gallery.editImageLabel": "Editar imagem da galeria",
    "gallery.fieldCategory": "Categoria",
    "gallery.fieldPromptNote": "Nota de referência",
    "gallery.fieldName": "Nome",
    "quickGallery.empty": "Nenhuma imagem {category}",
    "promptGallery.remove": "Remover @{name}",
    "prompt.title": "Alerta",
    "prompt.editorLabel": "Alerta",
    "prompt.placeholder": "Descreva a imagem que você deseja gerar ou editar. Digite @ para referências de galeria, # para códigos de cores e ~ para trechos de prompt.",
    "prompt.run": "Gerar",
    "prompt.runEdit": "Comece a editar",
    "prompt.runTitle": "Gerar (Cmd+Enter)",
    "prompt.runEditTitle": "Comece a editar (Cmd+Enter)",
    "prompt.findPanel": "Localizar e substituir prompt",
    "prompt.findText": "Encontrar texto",
    "prompt.replaceWith": "Substitua por",
    "prompt.findActions": "Localizar e substituir ações",
    "prompt.countZero": "0 partidas",
    "prompt.matchCount": "{count} corresponde",
    "prompt.foundCount": "Encontradas correspondências {count}",
    "prompt.noMatch": "Nenhum texto correspondente",
    "prompt.replacedCount": "Correspondências {count} substituídas",
    "prompt.closeFind": "Fechar localizar e substituir",
    "prompt.recentTemplates": "Modelos recentes",
    "prompt.manageTemplates": "Gerenciar modelos",
    "promptModel.galleryHeader": "Notas de imagem de referência:",
    "promptModel.galleryInstruction": "- Imagem de referência {number}: galeria \"{name}\", função: {role}. @{name} no prompt refere-se a esta imagem.{note}",
    "outputSettings.title": "Saída",
    "output.lock.lock": "Bloquear parâmetros",
    "output.lock.unlock": "Desbloquear e editar",
    "output.lock.current": "Bloqueio atual",
    "output.lock.task": "Parâmetros da tarefa",
    "output.lock.adoptTask": "Usar parâmetros desta tarefa",
    "output.lock.frame": "Enquadramento",
    "output.lock.outputCount": "Quantidade de saídas",
    "output.lock.output": "Saída",
"output.lock.search": "Pesquisa",
    "output.lock.call": "Chamada",
    "output.lock.sheets": "imagens",
    "output.lock.imageModel": "Modelo de imagem",
    "output.lock.prompt": "Prompt",
    "output.lock.fileFormat": "Formato de arquivo",
    "output.lock.taskHint": "Apenas os parâmetros da tarefa são exibidos; o bloqueio atual não muda. Usá-los não altera o canal do sistema.",
    "output.lock.lockedHint": "Os parâmetros estão fixos. Use o cadeado no canto superior para editar.",
    "output.lock.enabled": "Ativada",
    "output.lock.disabled": "Desativada",
    "output.mainModel": "Modelo principal",
    "output.selectMainModel": "Selecione o modelo principal",
    "output.mainModelCustomForInput": "Use um modelo personalizado para a entrada atual",
    "output.apiDirect": "API Direto",
    "output.apiToolModel": "Usando o modelo de geração de imagens API",
    "output.mainModelUnused": "O modelo principal não é usado para esta solicitação",
    "output.webSearch": "Pesquisa na web",
    "output.webSearchToggle": "Ligado",
    "output.webSearchTitle": "Pesquise primeiro na web e depois use-a para esta geração; Codex e API Responses apenas",
    "output.promptMode": "Tratamento do prompt",
    "output.modeOriginal": "Original",
    "output.modeStrict": "Fiel",
    "output.modeCreative": "Automático",
    "output.promptHelp": "Explicar o tratamento do prompt",
    "output.promptHelpTitle": "Tratamento do prompt",
    "output.promptHelp.responsesChannel": "Responses · modelo principal envolvido",
    "output.promptHelp.imagesChannel": "Images · geração direta",
    "output.promptHelp.responses.original": "Envia o texto original ao modelo principal e pede que a ferramenta de imagem o preserve; ainda assim pode gerar um revised prompt.",
    "output.promptHelp.responses.strict": "Permite que o modelo principal organize ou expanda o prompt, preservando restrições como temas, texto, cores e composição.",
    "output.promptHelp.responses.automatic": "Não adiciona restrições; o modelo principal interpreta e otimiza antes de chamar a ferramenta de imagem.",
    "output.promptHelp.images.original": "Não adiciona regras do aplicativo e envia o texto original diretamente à API de imagens.",
    "output.promptHelp.images.strict": "Envia regras de fidelidade junto com o prompt original para preservar todas as restrições.",
    "output.promptHelp.images.automatic": "Usa o tratamento padrão da API de imagens e inclui as notas necessárias de referências da galeria.",
    "output.sizeMode": "Modo de tamanho",
    "output.sizePreset": "Predefinido",
    "output.sizeCustom": "Personalizado",
    "output.orientation": "Orientação",
    "output.square": "Quadrado",
    "output.portrait": "Retrato",
    "output.landscape": "Paisagem",
    "output.resolution": "Resolução",
    "output.pixelSize": "Tamanho dos pixels",
    "output.width": "Largura",
    "output.height": "Altura",
    "output.swapSize": "Trocar largura e altura",
    "output.customSizeHint": "Unidade px · 16-3840 · múltiplo de 16 · ≤3:1",
    "output.imageSizeUnavailable": "Tamanho da imagem indisponível",
    "output.imageLoadFailed": "A imagem não foi carregada",
    "output.customSizeRequired": "Insira largura e altura",
    "output.customSizeBounds": "A largura e a altura devem ser de 16 a 3840 px",
    "output.customSizeMultiple": "A largura e a altura devem ser múltiplos de 16",
    "output.customSizeRatio": "A proporção do lado longo para o curto não pode exceder 3:1",
    "output.customSizePixels": "O total de pixels deve ser de 655.360 a 8.294.400",
    "output.ratioLock": "Bloqueio de proporção (opcional)",
    "output.customRatio": "Proporção personalizada",
    "output.ratioWidth": "W",
    "output.ratioHeight": "H",
    "output.firstImageRatio": "Use a primeira proporção da imagem de referência",
    "output.useFirstImage": "Da imagem",
    "output.ratioHint": "Deixe em branco para tamanho livre · Preencha ambos para sincronizar",
    "output.ratio": "Proporção",
    "output.quality": "Qualidade",
    "output.qualityAuto": "Automático",
    "output.qualityLow": "Baixo",
    "output.qualityMedium": "Médio",
    "output.qualityHigh": "Alto",
    "output.quantity": "Contar",
    "output.pixelPreview": "Pixels de saída: 1024 x 1024 px",
    "output.pixelPreviewValue": "Pixels de saída: {value}",
    "output.pixelPreviewAuto": "Pixels de saída: automático (OpenAI escolhe automaticamente)",
    "output.format": "Formato",
    "output.compression": "Compressão",
    "output.moderation": "Moderação",
    "preview.title": "Visualização",
    "preview.selectedZero": "0 selecionado",
    "preview.selectedCount": "Selecionado {selected}/{total}",
    "preview.downloadSelected": "Download selecionado",
    "preview.deleteUnselected": "Excluir não selecionado",
    "preview.downloadAll": "Baixar ZIP",
    "preview.empty": "Ainda não há imagens",
    "preview.taskFailed": "Falha na tarefa",
    "preview.partialFailed": "Algumas imagens falharam",
    "preview.failedOutput": "Imagem {index} falhou",
    "preview.progressLine": "Concluído {generated} / {total} · decorrido {elapsed}",
    "preview.failureLine": "Concluído {generated} / {total} · falhou {failed}",
    "preview.elapsedLine": "Decorrido {elapsed}",
    "preview.lastError": "Último erro: {error}",
    "preview.continueGenerating": "Geração contínua",
    "preview.waitingContinue": "Esperando para continuar",
    "preview.retryFailed": "Tentar novamente imagens com falha",
    "preview.acceptSuccesses": "Aceite resultados bem-sucedidos",
    "preview.generateMode": "Geração",
    "preview.editMode": "Editar",
    "preview.runningTitle": "{mode} em execução",
    "preview.submittingTitle": "Enviando tarefa",
    "preview.queuedTitle": "Tarefa na fila",
    "preview.submittingDetail": "Salvando entradas e adicionando a tarefa à fila. A geração começará automaticamente.",
    "preview.queuedDetail": "A tarefa está na fila e aguardando um canal disponível.",
    "preview.featured": "Selecionado",
    "preview.addFeatured": "Selecione o resultado",
    "preview.selectedFeatured": "Selecionado",
    "preview.removeFeatured": "Desmarcar resultado",
    "preview.selectionAdded": "Resultado selecionado",
    "preview.selectionRemoved": "Resultado desmarcado",
    "preview.selectionUpdateFailed": "Falha ao atualizar a seleção",
    "preview.noUnselectedOutputs": "Não há imagens não selecionadas para excluir",
    "preview.deleteUnselectedTitle": "Excluir imagens não selecionadas?",
    "preview.deleteUnselectedMessage": "Isso excluirá os arquivos de imagem locais dos resultados não selecionados nesta tarefa.",
    "preview.deleteUnselectedDetail": "Mantenha {selected}, exclua {deleted}",
    "preview.deleteUnselectedFailed": "Falha ao excluir imagens não selecionadas",
    "preview.deleteUnselectedDone": "Imagens não selecionadas excluídas",
    "preview.addReference": "Adicionar referência",
    "preview.stage": "Palco",
    "preview.stageReference": "Estágio como referência pendente",
    "preview.prompt": "Alerta",
    "preview.download": "Baixar",
    "preview.downloadImage": "Baixe esta imagem",
    "lightbox.label": "Visualização da imagem",
    "lightbox.close": "Fechar visualização",
    "lightbox.previous": "Imagem anterior",
    "lightbox.next": "Próxima imagem",
    "promptPopover.title": "Comparação imediata",
    "promptPopover.summary": "{original} original · {optimized} otimizado",
    "promptPopover.original": "Solicitação original",
    "promptPopover.optimized": "Solicitação otimizada",
    "promptPopover.charCount": "{count} caracteres",
    "promptPopover.empty": "Nenhum",
    "promptPopover.notReturned": "Não devolvido",
    "promptPopover.noOptimized": "Nenhum prompt otimizado foi retornado",
    "promptPopover.submitted": "Ver solicitação enviada",
    "promptPopover.close": "Fechar comparação imediata",
    "promptPopover.copyOptimized": "Copiar prompt otimizado",
    "promptPopover.copied": "Copiado",
    "taskContext.menuLabel": "Menu de contexto da tarefa",
    "taskContext.view": "Ver tarefa",
    "taskContext.copyId": "Copiar tarefa ID",
    "taskContext.copyPrompt": "Solicitação de cópia",
    "taskContext.revealOutput": "Abra a pasta de saída",
    "taskContext.archive": "Tarefa de arquivamento",
    "taskContext.delete": "Excluir tarefa",
    "taskContext.idCopied": "Tarefa ID copiada",
    "taskContext.promptCopied": "Prompt copiado",
    "taskContext.noPrompt": "Esta tarefa não tem prompt para copiar",
    "taskContext.revealFailed": "Falha ao abrir a pasta de saída",
    "taskContext.revealOpened": "Pasta de saída aberta",
    "taskContext.actionFailed": "Falha na ação da tarefa",
    "taskActions.group": "Ações de tarefa",
    "taskActions.deleteTitle": "Excluir tarefa?",
    "taskActions.deleteMessage": "Isso também excluirá os arquivos de imagem locais.",
    "taskActions.runningCannotDelete": "As tarefas em execução não podem ser excluídas",
    "taskActions.updated": "Status da tarefa atualizado",
    "taskActions.archived": "Bate-papo arquivado",
    "taskActions.archiveFailed": "Falha no arquivamento",
    "taskActions.deleted": "Tarefa excluída",
    "taskActions.deleteFailed": "Falha na exclusão",
    "taskActions.noRetryableFailedImages": "Esta tarefa não tem imagens com falha para tentar novamente",
    "taskActions.retryFailedOutputsFailed": "Falha ao tentar novamente imagens com falha",
    "taskActions.requeuedFailedImages": "Imagens com falha recolocadas na fila",
    "taskActions.noAcceptableSuccessImages": "Esta tarefa não tem imagens bem-sucedidas para aceitar",
    "taskActions.acceptSuccessesFailed": "Falha ao aceitar resultados bem-sucedidos",
    "taskActions.acceptedSuccesses": "Resultados bem-sucedidos aceitos",
    "taskActions.viewedUpdateFailed": "Falha ao atualizar o estado de leitura",
    "taskActions.failedFallback": "Falha na tarefa",
    "taskList.empty": "Ainda não há histórico",
    "taskList.selectSession": "Selecione bate-papo",
    "taskList.unreadUpdate": "Atualização não lida",
    "taskList.viewing": "Visualizando",
    "taskDerived.usageLimited": "Uso limitado",
    "taskSubmit.requestFailed": "Falha na solicitação",
    "taskSubmit.queued": "Tarefa adicionada à fila",
    "taskSubmit.timeout": "O envio da tarefa expirou antes que o back-end respondesse. Atualize a fila para confirmar se ela foi adicionada e, em seguida, decida se deseja tentar novamente.",
    "taskSubmit.failed": "Falha no envio da tarefa",
    "templates.title": "Modelos de prompt",
    "templates.summary": "Biblioteca de modelos locais",
    "templates.availableCount": "{count} modelos disponíveis",
    "templates.noMatch": "Nenhum modelo correspondente",
    "templates.empty": "Nenhum modelo",
    "templates.favoriteBadge": "Favorito",
    "templates.usageCount": "{count} usa",
    "templates.back": "Voltar",
    "templates.edit": "Editar",
    "templates.copy": "Copiar",
    "templates.insert": "Inserir",
    "templates.formTitle": "Título",
    "templates.formShortTitle": "Título curto",
    "templates.formCategory": "Categoria",
    "templates.formTags": "Etiquetas",
    "templates.formThumbnail": "Miniatura",
    "templates.formContent": "Conteúdo",
    "templates.formNotes": "Notas",
    "templates.formFavorite": "Favorito",
    "templates.thumbnailClear": "Limpar",
    "templates.thumbnailNone": "Nenhum selecionado",
    "templates.thumbnailEmpty": "Sem miniaturas de histórico",
    "templates.newCategory": "Nova categoria",
    "templates.search": "Pesquise modelos, tags ou conteúdo",
    "templates.filter": "Filtros de modelo",
    "templates.all": "Todos",
    "templates.categoryCommon": "Comum",
    "templates.categoryPortrait": "Retrato",
    "templates.categoryProduct": "Produto",
    "templates.categoryRepair": "Reparar",
    "templates.categoryPoster": "Pôster",
    "templates.categoryEcommerce": "Comércio eletrônico",
    "templates.favorite": "Favoritos",
    "templates.recent": "Recente",
    "templates.category": "Categorias",
    "templates.loadFailed": "Falha ao carregar modelos de prompt",
    "templates.useStateUpdateFailed": "Falha ao atualizar o estado de uso do modelo de prompt",
    "templates.copied": "Modelo de prompt copiado",
    "templates.copyFailed": "Falha ao copiar o modelo de prompt",
    "templates.history": "História",
    "templates.saveFailed": "Falha ao salvar o modelo de prompt",
    "templates.saved": "Modelo de prompt salvo",
    "templates.deleteFailed": "Falha ao excluir modelo de prompt",
    "templates.deleted": "Modelo de prompt excluído",
    "templates.categoryAddFailed": "Falha ao adicionar categoria de modelo",
    "templates.categoryAdded": "Categoria de modelo adicionada",
    "templates.categorySaveFailed": "Falha ao salvar a categoria do modelo",
    "templates.categorySaved": "Categoria de modelo salva",
    "templates.categoryDeleteFailed": "Falha ao excluir categoria de modelo",
    "templates.categoryDeleted": "Categoria de modelo excluída",
    "templates.importFailed": "Falha ao importar pacote de modelos",
    "templates.importedCount": "Modelos {count} importados",
    "templates.exportFailed": "Falha ao exportar pacote de modelos",
    "templates.exported": "Pacote de modelos exportado",
    "snippets.suggestLabel": "Seletor de snippet de prompt",
    "snippets.saveSelection": "Salvar",
    "snippets.saveSelectionLabel": "Salvar o texto selecionado como um trecho de prompt",
    "snippets.popoverLabel": "Trecho de prompt",
    "snippets.defaultCategory": "Comum",
    "snippets.loadFailed": "Falha ao carregar trechos de prompt",
    "snippets.remove": "Remover ~{tag}",
    "snippets.expand": "Expandir",
    "snippets.edit": "Editar",
    "snippets.close": "Fechar",
    "snippets.editTitle": "Editar trecho",
    "snippets.saveTitle": "Salvar trecho",
    "snippets.shortTag": "Etiqueta curta",
    "snippets.title": "Título",
    "snippets.category": "Categoria",
    "snippets.content": "Conteúdo",
    "snippets.titlePlaceholder": "Usa tag curta por padrão",
    "snippets.cancel": "Cancelar",
    "snippets.save": "Salvar",
    "snippets.saveFailed": "Falha ao salvar o snippet de prompt",
    "snippets.saved": "Snippet de prompt salvo",
    "snippets.defaultTag": "Trecho comum",
    "colors.white": "Branco",
    "colors.black": "Preto",
    "colors.warmBeige": "Bege quente",
    "colors.lightGreen": "Verde claro",
    "colors.brandGreen": "Marca verde",
    "colors.peachOrange": "Laranja pêssego",
    "colors.lightBlue": "Azul claro",
    "colors.lightPink": "Rosa claro",
    "colors.loadFailed": "Falha ao carregar as configurações de cores",
    "colors.saveFailed": "Falha ao salvar as configurações de cores",
    "colors.importFailed": "Falha ao importar configurações de cores",
    "colors.importedCount": "Cores {count} importadas",
    "colors.recentSaveFailed": "Falha ao salvar cores recentes",
    "colors.favoriteSaveFailed": "Falha ao salvar a cor favorita",
    "colors.favoriteDeleteFailed": "Falha ao excluir a cor favorita",
    "colors.update": "Atualizar",
    "colors.insert": "Inserir",
    "colors.pick": "Escolha a cor",
    "colors.pickShort": "Escolha",
    "colors.hexValue": "Valor da cor",
    "colors.pendingUpdate": "A cor mudou. Clique em Atualizar para aplicar.",
    "colors.save": "Salvar",
    "colors.exportPs": "Exportar",
    "colors.importPs": "Importar",
    "colors.done": "Concluído",
    "colors.manage": "Gerenciar",
    "colors.favorites": "Cores favoritas",
    "colors.recent": "Cores recentes",
    "colors.recentLabel": "Recente",
    "colors.deleteFavorite": "Excluir cor favorita {name}",
    "colors.modify": "Editar cor",
    "colors.modifyValue": "Editar cor {value}",
    "colors.removeValue": "Remover cor {value}",
    "taskGroup.today": "Hoje",
    "taskGroup.yesterday": "Ontem",
    "taskGroup.last7": "Últimos 7 dias",
    "taskGroup.older": "Mais velho",
    "taskGroup.searchResults": "Resultados da pesquisa",
    "taskGroup.active": "Ativo",
    "taskGroup.running": "Correndo",
    "taskGroup.waiting": "Esperando",
    "taskGroup.dispatchPending": "Atribuindo um canal disponível...",
    "taskGroup.expand": "Expandir {label}",
    "taskGroup.collapse": "Recolher {label}",
    "taskGroup.buttonLabel": "Tarefas {label}, {count}",
    "archive.title": "Arquivo",
    "archive.empty": "Nenhum bate-papo arquivado",
    "archive.count": "{count} bate-papos arquivados",
    "archive.restore": "Restaurar",
    "archive.archiveFailed": "Falha no arquivamento",
    "archive.restoreFailed": "Falha na restauração",
    "archive.restored": "Bate-papo restaurado",
    "archive.archiving": "Arquivando...",
    "archive.restoring": "Restaurando...",
    "archive.deleting": "Excluindo...",
    "archive.restoredCount": "Tarefas {count} restauradas",
    "settings.title": "Armazenamento",
    "settings.status": "Reinicie WebUI após salvar os caminhos de armazenamento",
    "settings.inputRoot": "Pasta de entrada",
    "settings.outputRoot": "Pasta de saída",
    "settings.galleryRoot": "Pasta da galeria",
    "settings.sourceDataRoot": "Pasta de dados de origem",
    "settings.language": "Idioma da interface",
    "settings.languageCopy": "Na primeira inicialização, a interface segue o idioma do seu navegador. As escolhas manuais são lembradas.",
    "settings.notificationsCopy": "Notifique quando as tarefas forem concluídas ou falharem. As notificações do sistema devem ser habilitadas manualmente.",
    "settings.inAppNotification": "Notificações no aplicativo",
    "settings.systemNotification": "Notificações do sistema",
    "settings.save": "Salvar configurações",
    "settings.loadFailed": "Falha ao carregar as configurações",
    "settings.saveFailed": "Falha ao salvar as configurações",
    "settings.savedRestart": "Configurações de armazenamento salvas. Reinicie WebUI para aplicar.",
    "settings.saved": "Salvo",
    "settings.savedRestartStatus": "Configurações de armazenamento salvas. Reinicie WebUI para aplicar.",
    "systemSettings.title": "Configurações do sistema",
    "systemSettings.tabsLabel": "Seções de configurações do sistema",
    "systemSettings.apiTab": "API Configurações",
    "systemSettings.codexTab": "Codex Canal",
    "systemSettings.languageTab": "Idioma / Language",
    "systemSettings.storageTab": "Armazenamento e notificações",
    "languageSettings.instantStatus": "As alterações de idioma são aplicadas imediatamente",
    "apiSettings.title": "API Configurações",
    "apiSettings.status": "As configurações salvas são aplicadas imediatamente no modo API",
    "apiSettings.codexMode": "canal Codex",
    "apiSettings.codexImages": "Image",
    "apiSettings.codexResponses": "Responses",
    "apiSettings.providers": "API provedores",
    "apiSettings.searchProviders": "Buscar nomes de provedores",
    "apiSettings.noProviderSearchResults": "Nenhum provedor correspondente",
    "apiSettings.providerCount": "{count} provedores",
    "apiSettings.provider": "Provedor",
    "apiSettings.providerName": "Nome do provedor",
    "apiSettings.actualRequest": "Solicitação efetiva",
    "apiSettings.newProviderAction": "Novo provedor",
    "apiSettings.copyProvider": "Copiar",
    "apiSettings.copyProviderName": "{name} Copiar",
    "apiSettings.copyProviderStatus": "Provedor copiado com sua chave salva. Edite o nome, modelo ou substitua a chave antes de salvar.",
    "apiSettings.copyProviderWithoutKeyStatus": "Provedor copiado. Edite o nome, modelo ou adicione uma chave API antes de salvar.",
    "apiSettings.sortProviders": "Classificar",
    "apiSettings.finishSortProviders": "Concluído",
    "apiSettings.sortProviderModeStatus": "Classificando provedores",
    "apiSettings.sortProviderStatus": "Ordem do provedor alterada. Salvando automaticamente...",
    "apiSettings.moveProviderUp": "Acima",
    "apiSettings.moveProviderDown": "Para baixo",
    "apiSettings.moveProviderUpAria": "Mova {provider} para cima",
    "apiSettings.moveProviderDownAria": "Mova {provider} para baixo",
    "apiSettings.mode": "Modo de solicitação",
    "apiSettings.images": "Imagem Direta API",
    "apiSettings.responses": "Responses API",
    "apiSettings.modeImagesShort": "Direto",
    "apiSettings.imageModel": "Modelo de geração de imagens",
    "apiSettings.concurrency": "Limite de simultaneidade",
    "apiSettings.concurrencyShort": "Simultaneidade",
    "apiSettings.advancedSettings": "Configurações avançadas",
    "apiSettings.concurrencyValue": "simultaneidade {concurrency}",
    "apiSettings.keySaved": "Chave API salva",
    "apiSettings.keyNotSet": "Chave API não definida",
    "apiSettings.showApiKey": "Mostrar API Key",
    "apiSettings.hideApiKey": "Ocultar API Key",
    "apiSettings.editProvider": "Editar provedor",
    "apiSettings.newProviderTitle": "Novo provedor",
    "apiSettings.editHint": "O provedor de salvamento grava esta edição no back-end. Cancelar descarta-o.",
    "apiSettings.finishEditFirst": "Salve ou cancele a edição do provedor atual primeiro",
    "apiSettings.newDraftStatus": "Criando provedor. Salve o provedor para se inscrever.",
    "apiSettings.editDraftStatus": "Provedor de edição. Salve o provedor para se inscrever.",
    "apiSettings.cancelEdit": "Cancelar edição",
    "apiSettings.saveProvider": "Salvar provedor",
    "apiSettings.saveSelection": "Salvar seleção",
    "apiSettings.deleteProviderTitle": "Excluir provedor?",
    "apiSettings.deleteProviderMessage": "Excluir \"{provider}\"?",
    "apiSettings.deleteProviderDetail": "Isso o remove da lista de provedores e salva automaticamente no back-end.",
    "apiSettings.deleteProviderStatus": "Provedor excluído. Salvando automaticamente...",
    "apiSettings.save": "Salvar configurações de API",
    "apiSettings.loadFailed": "Falha ao carregar configurações de API",
    "apiSettings.savedKeyPlaceholder": "A chave API é salva no backend. Insira uma nova chave para substituí-la.",
    "apiSettings.newProvider": "Novo provedor",
    "apiSettings.saving": "Salvando...",
    "apiSettings.savingStatus": "Salvando configurações de API...",
    "apiSettings.autoSaving": "Salvando automaticamente...",
    "apiSettings.autoSaved": "Salvo automaticamente",
    "apiSettings.saveFailed": "Falha ao salvar as configurações de API",
    "apiSettings.savedSummary": "Salvo · Codex {codex} · API {provider} · {mode} · {model} · simultaneidade {concurrency}",
    "apiSettings.savedShort": "Salvo",
    "apiSettings.savedStatus": "API configurações salvas",
    "apiSettings.saveFailedShort": "Falha ao salvar",
    "codexSettings.title": "Codex Canal",
    "codexSettings.status": "Escolha o canal de geração para o login Codex local",
    "codexSettings.notesLabel": "Codex notas do canal",
    "codexSettings.imagesTitle": "Codex Image",
    "codexSettings.imagesCopy": "Canal padrão para passar parâmetros de tamanho, qualidade e edição diretamente.",
    "codexSettings.responsesTitle": "Codex Responses",
    "codexSettings.responsesCopy": "Canal de compatibilidade para fluxos de trabalho que necessitam de ferramentas de pesquisa na web.",
    "codexSettings.current": "Atual",
    "codexSettings.save": "Salvar canal Codex",
    "codexSettings.saveMode": "Salvar {mode}",
    "imageEditor.title": "Editar imagem de entrada",
    "imageEditor.promptHint": "Setas e marcas desenhadas à mão na imagem são apenas instruções. Não os mantenha na imagem final.",
    "imageEditor.inputFallback": "Imagem de entrada",
    "imageEditor.openFailed": "Falha ao abrir esta imagem para edição",
    "imageEditor.loadForEditFailed": "Falha ao carregar esta imagem para edição",
    "imageEditor.canvasCreateFailed": "Falha ao criar a tela de edição de imagem",
    "imageEditor.closedRegionRequired": "Use o pincel para desenhar primeiro uma região fechada",
    "imageEditor.saveFailed": "Falha ao salvar a edição da imagem",
    "imageEditor.saved": "Imagem de entrada editada salva",
    "imageEditor.uneditable": "Esta imagem não pode ser editada",
    "imageEditor.resetDone": "Redefinir para a imagem original",
    "imageEditor.resetFailed": "Falha ao redefinir a imagem original",
    "imageEditor.subtitle": "Corte, desenhe, preencha ou adicione setas e salve como uma nova imagem de entrada",
    "imageEditor.toolbar": "Barra de ferramentas do editor de imagens",
    "imageEditor.tools": "Ferramentas",
    "imageEditor.select": "Selecionar",
    "imageEditor.brush": "Pincel",
    "imageEditor.arrow": "Flecha",
    "imageEditor.crop": "Cortar",
    "imageEditor.fill": "Preencher",
    "imageEditor.fillLabel": "Preenchimento de balde de tinta",
    "imageEditor.eraser": "Borracha",
    "imageEditor.colors": "Cores",
    "imageEditor.red": "Vermelho",
    "imageEditor.blue": "Azul",
    "imageEditor.green": "Verde",
    "imageEditor.yellow": "Amarelo",
    "imageEditor.white": "Branco",
    "imageEditor.black": "Preto",
    "imageEditor.customColor": "Cor personalizada",
    "imageEditor.stroke": "acidente vascular cerebral",
    "imageEditor.history": "História",
    "imageEditor.undo": "Desfazer",
    "imageEditor.redo": "Refazer",
    "imageEditor.reset": "Redefinir imagem",
    "imageEditor.canvas": "Tela de edição de imagem",
    "imageEditor.canvasScope": "Área da tela",
    "imageEditor.canvasScopeBase": "Imagem base",
    "imageEditor.canvasScopeFit": "Ajustar às camadas",
    "imageEditor.canvasFitDone": "Tela ajustada à área das camadas",
    "imageEditor.canvasBaseDone": "Tela restaurada para a imagem base",
    "imageEditor.insertImages": "Inserir imagens",
    "imageEditor.layers": "Camadas",
    "imageEditor.layerUp": "Mover para cima",
    "imageEditor.layerDown": "Mover para baixo",
    "imageEditor.emptyInsertList": "Não há outras imagens de entrada",
    "imageEditor.selectLayerFirst": "Selecione uma camada primeiro",
    "imageEditor.baseLayer": "Imagem base",
    "gallery.title": "Galeria",
    "gallery.subtitle": "Escolha imagens de referência para a tarefa atual",
    "gallery.manageCategories": "Gerenciar categorias",
    "gallery.categoryManager": "Gerenciar categorias de galeria",
    "gallery.categoryManagement": "Gerenciamento de categorias",
    "gallery.categoryCopy": "As categorias são salvas na galeria; as funções de prompt descrevem como as referências são usadas.",
    "gallery.newCategoryName": "Novo nome de categoria",
    "gallery.newCategoryRole": "Função imediata, por ex. referência de estilo",
    "gallery.addCategory": "Adicionar categoria",
    "gallery.drawerSubtitle": "Categoria atual: {category}. Clique em \"Usar\" para adicioná-lo à entrada de imagem.",
    "gallery.emptyCategory": "Ainda não há imagens nesta categoria",
    "gallery.dragSort": "Arraste para classificar",
    "gallery.dragSortImage": "Imagem de arrastar e classificar {name}",
    "gallery.dragSortCategory": "Categoria de classificação por arrastamento {name}",
    "gallery.use": "Usar",
    "gallery.replace": "Substituir",
    "gallery.rename": "Renomear",
    "gallery.moveCategory": "Categoria",
    "gallery.note": "Nota",
    "gallery.delete": "Excluir",
    "gallery.uncategorized": "Sem categoria",
    "addGallery.title": "Adicionar à galeria",
    "addGallery.copy": "Os nomes são globalmente exclusivos e podem ser referenciados com @name posteriormente",
    "addGallery.name": "Nome",
    "addGallery.namePlaceholder": "Exemplo: Mia",
    "addGallery.category": "Categoria",
    "addGallery.note": "Nota de referência",
    "addGallery.notePlaceholder": "Exemplo: faça referência apenas ao rosto e ao cabelo, não às roupas ou ao fundo",
    "addGallery.save": "Salvar na galeria",
    "close.promptTemplates": "Fechar painel de modelos de prompt",
    "close.archive": "Fechar painel de arquivo",
    "close.settings": "Fechar painel de configurações de armazenamento",
    "close.apiSettings": "Fechar painel de configurações API",
    "close.systemSettings": "Fechar painel de configurações do sistema",
    "close.imageEditor": "Fechar painel do editor de imagens",
    "close.gallery": "Fechar painel da galeria",
    "close.addGallery": "Fechar adicionar ao painel da galeria",
    "close.version": "Fechar painel de atualização de versão",
    "imageInput.referenceTitle": "Entrada de referência (opcional)",
    "referenceFiles.add": "Adicionar arquivo",
    "referenceFiles.selected": "Arquivos de referência",
    "referenceFiles.recent": "Arquivos recentes",
    "referenceFiles.familyPdf": "Páginas + texto",
    "referenceFiles.familySpreadsheet": "Planilha",
    "referenceFiles.familyDocument": "Documento",
    "referenceFiles.familyText": "Texto",
    "referenceFiles.visualLimit": "Arquivos que não sejam PDF não preservam imagens e gráficos incorporados. Converta para PDF quando o layout for importante.",
    "referenceFiles.remove": "Remover {filename}",
    "referenceFiles.switchTitle": "Remover arquivos de referência?",
    "referenceFiles.switchMessage": "Arquivos de referência funcionam apenas com Responses. Remova-os antes de mudar para Images.",
    "referenceFiles.removeAndSwitch": "Remover arquivos e mudar",
    "referenceFiles.requiresResponses": "Arquivos de referência exigem Responses",
    "referenceFiles.switchToResponses": "Mudar para Responses",
    "referenceFiles.openApiSettings": "Abrir configurações da API",
    "referenceFiles.providerMissing": "O provedor Responses original não está disponível. Escolha um nas configurações da API.",
    "referenceFiles.missing": "Arquivo ausente",
    "referenceFiles.loadFailed": "Falha ao carregar arquivos de referência",
    "referenceFiles.errorEmpty": "O arquivo de referência está vazio",
    "referenceFiles.errorUnsupported": "Este tipo de arquivo de referência não é compatível",
    "referenceFiles.errorMismatch": "O conteúdo não corresponde à extensão",
    "referenceFiles.errorInvalid": "O arquivo de referência é inválido",
    "referenceFiles.errorTooLarge": "Cada arquivo de referência deve ter menos de 50 MB",
    "referenceFiles.errorTotalTooLarge": "Os arquivos de referência podem somar no máximo 50 MB",
    "referenceFiles.errorMissing": "Um arquivo de referência selecionado está ausente",
    "referenceFiles.errorProviderUnsupported": "O Responses deste provedor não aceita arquivos de referência",
    "referenceFiles.responsesEnabled": "Responses ativado",
    "referenceFiles.historyPathMismatch": "Estes arquivos usam caminhos Responses diferentes",
    "history.referenceFiles": "Arquivos de referência",
    "history.downloadReferenceFile": "Baixar arquivo",
    "history.readdReferenceFile": "Adicionar novamente",
};
